import { FbwA32NxChecklistMarketingSeo } from "../../../content/templateMarketing/fbw-a32nx-seo";
import { AircraftAddonTemplate } from "../../../lib/model/addonTemplate";
import fbwA32NXImage from "../../images/templates/fbw-a32nx.png";

export const fbwA32NXTemplate: AircraftAddonTemplate = {
  type: "aircraft",
  title: "FlyByWire A32NX",
  id: "fbw-a32nx",
  platforms: ["msfs"],
  image: fbwA32NXImage,
  infoMarketingBlurb: FbwA32NxChecklistMarketingSeo,
  content: [
    {
      title: "Cockpit Preparation",
      roles: ["cockpitPreparation"],
      content: [
        {
          item: "Gear Pins and Covers",
          setting: "Removed",
        },
        {
          item: "ADIRS",
          setting: "Nav",
        },
        {
          item: "Fuel Quantity",
          setting: "____ KG/LB",
        },
        {
          item: "Baro Ref",
          setting: "____ Set (Both)",
        },
        {
          item: "Seat Belts Sign",
          setting: "On",
        },
        {
          item: "No Smoking Sign",
          setting: "On",
        },
        {
          item: "Emergency Exit Lights",
          setting: "Armed",
        },
        {
          item: "Nav & Logo Lights",
          setting: "On",
        },
      ],
    },
    {
      title: "Before Start",
      roles: ["beforeFlightStart", "beforeEngineStart", "beforePushback"],
      content: [
        {
          item: "Parking Brake",
          setting: "____",
        },
        {
          item: "APU",
          setting: "Avail",
        },
        {
          item: "Takeoff Speeds & Thrust",
          setting: "____ (Both)",
        },
        {
          item: "Window",
          setting: "Closed (Both)",
        },
        {
          item: "Beacon",
          setting: "On",
        },
      ],
    },
    {
      title: "After Start",
      roles: ["afterEngineStart", "beforeTaxi"],
      content: [
        {
          item: "Eng Mode Selector",
          setting: "Norm",
        },
        {
          item: "APU Bleed",
          setting: "Off",
        },
        {
          item: "Anti Ice",
          setting: "____",
        },
        {
          item: "ECAM Status",
          setting: "Checked",
        },
        {
          item: "Ground Spoilers",
          setting: "Armed",
        },
        {
          item: "Pitch Trim",
          setting: "____ %",
        },
        {
          item: "Rudder Trim",
          setting: "Neutral",
        },
      ],
    },
    {
      title: "Taxi",
      roles: ["taxi"],
      content: [
        {
          item: "Nose Light",
          setting: "Taxi",
        },
        {
          item: "Flight Controls",
          setting: "Checked (Both)",
        },
        {
          item: "Flap Setting",
          setting: "Conf ____ (Both)",
        },
        {
          item: "Radar & Pred. W/S",
          setting: "On & Auto",
        },
        {
          item: "Eng Mode Sel",
          setting: "____",
        },
        {
          item: "ECAM Memo",
          setting: "Takeoff No Blue",
        },
        {
          item: "Cabin",
          setting: "Ready",
        },
      ],
    },
    {
      title: "Line-Up",
      roles: ["beforeTakeoff", "takeoff"],
      content: [
        {
          item: "Takeoff Runway",
          setting: "____ (Both)",
        },
        {
          item: "TCAS",
          setting: "____",
        },
        {
          item: "Packs 1 & 2",
          setting: "____",
        },
        {
          item: "Strobe Lights",
          setting: "On",
        },
        {
          header: "Cleared for Takeoff",
        },
        {
          item: "Nose Lights",
          setting: "Takeoff",
        },
        {
          item: "Rwy Turn Off Lights",
          setting: "On",
        },
        {
          item: "Landing Lights",
          setting: "On",
        },
      ],
    },
    {
      title: "Approach",
      roles: ["approach"],
      content: [
        {
          item: "Baro Ref",
          setting: "____ Set (Both)",
        },
        {
          item: "Seat Belts",
          setting: "On",
        },
        {
          item: "Minimums",
          setting: "____",
        },
        {
          item: "Autobrake",
          setting: "____",
        },
        {
          item: "Eng Mode Sel",
          setting: "As Required",
        },
      ],
    },
    {
      title: "Landing",
      roles: ["landing"],
      content: [
        {
          item: "ECAM Memo",
          setting: "Landing No Blue",
        },
        {
          item: "Cabin",
          setting: "Ready",
        },
      ],
    },
    {
      title: "After Landing",
      roles: ["afterLanding"],
      content: [
        {
          item: "Radar & Pred. W/S",
          setting: "Off",
        },
        {
          item: "Landing Lights",
          setting: "Off",
        },
        {
          item: "Strobe Lights",
          setting: "Off",
        },
        {
          item: "Nose Light",
          setting: "Taxi",
        },
        {
          item: "APU",
          setting: "Start",
        },
      ],
    },
    {
      title: "Parking",
      roles: ["parking", "shutdown"],
      content: [
        {
          item: "Parking Brake/Chocks",
          setting: "Set",
        },
        {
          item: "Engines",
          setting: "Off",
        },
        {
          item: "Wing Lights",
          setting: "Off",
        },
        {
          item: "Fuel Pumps",
          setting: "Off",
        },
        {
          item: "Yellow Elec Pump",
          setting: "Off",
        },
      ],
    },
    {
      title: "Securing the Aircraft",
      roles: ["securing"],
      content: [
        {
          item: "Oxygen",
          setting: "Off",
        },
        {
          item: "Emergency Exit Light",
          setting: "Off",
        },
        {
          item: "Batteries",
          setting: "Off",
        },
      ],
    },
  ],
};
